import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=1d24fd5d&"
import script from "./Pagination.ts?vue&type=script&lang=js&"
export * from "./Pagination.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports